import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ead41a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { for: "filtraSelecoes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelecaoComponent = _resolveComponent("SelecaoComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("article", null, [
      _createElementVNode("header", null, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.estaQuestao.getTitulo()), 1),
        (_ctx.estaQuestao.getSubtitulo())
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.estaQuestao.getSubtitulo()), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_2, [
        _createTextVNode(" Filtrar seleções "),
        _withDirectives(_createElementVNode("input", {
          type: "search",
          id: "filtroSelecoes",
          name: "filtroSelecoes",
          placeholder: "Filtrar Seleções",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtroSelecoes) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.filtroSelecoes]
        ])
      ]),
      _createElementVNode("fieldset", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selecaoesFiltradas, (selecao) => {
          return (_openBlock(), _createBlock(_component_SelecaoComponent, {
            key: selecao.getId(),
            "valores-selecionados": _ctx.selecoes,
            selecao: selecao as Selecao,
            questaoId: _ctx.estaQuestao.getId(),
            onValorSelecionado: _ctx.selecionarValor,
            onValorDeselecionado: _ctx.deselecionarValor
          }, null, 8, ["valores-selecionados", "selecao", "questaoId", "onValorSelecionado", "onValorDeselecionado"]))
        }), 128))
      ])
    ])
  ]))
}